import { render, staticRenderFns } from "./trips.vue?vue&type=template&id=30487fd3&scoped=true"
import script from "./trips.vue?vue&type=script&lang=js"
export * from "./trips.vue?vue&type=script&lang=js"
import style0 from "./trips.vue?vue&type=style&index=0&id=30487fd3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30487fd3",
  null
  
)

export default component.exports